import { useState } from 'react';
import { Button, Stack, TextField } from '@mui/material';

import useBoardStore from '../../store/boardStore';

const JoinBoardAsParticipant = () => {
  const joinBoardAsParticipant = useBoardStore((state) => state.joinBoardAsParticipant);
  const [participantName, setParticipantName] = useState('');
  const [joinError, setJoinError] = useState<string | null>(null);
  const [isJoining, setIsJoining] = useState(false);

  const joinAsParticipant = async () => {
    if (isJoining) {
      return;
    }

    setIsJoining(true);
    const error = await joinBoardAsParticipant(participantName);

    if (error) {
      setJoinError(error);
      setIsJoining(false);
      return;
    }

    setJoinError(null);
    setParticipantName('');
    setIsJoining(false);
  };

  return (
    <Stack direction="row" spacing={1} sx={{ width: '100%', alignItems: 'center' }}>
      <TextField
        size="small"
        variant="outlined"
        placeholder="Enter your name"
        value={participantName}
        error={Boolean(joinError)}
        title={joinError ?? undefined}
        onChange={(event) => {
          setParticipantName(event.target.value);
          if (joinError) {
            setJoinError(null);
          }
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            void joinAsParticipant();
          }
        }}
        sx={{ flex: 1, minWidth: { xs: 160, sm: 220 } }}
      />
      <Button variant="contained" onClick={() => void joinAsParticipant()} disabled={isJoining}>
        {isJoining ? 'Joining...' : 'Join'}
      </Button>
    </Stack>
  );
};

export default JoinBoardAsParticipant;
